module.exports = __webpack_public_path__ + "static/sheepgown-a0b25eead9183ae2510aed7509b308c6.jpeg";